import { render, staticRenderFns } from "./ForgotPasswordView.vue?vue&type=template&id=af3e106c"
import script from "./ForgotPasswordView.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordView.vue?vue&type=script&lang=js"
import style0 from "./ForgotPasswordView.vue?vue&type=style&index=0&id=af3e106c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports